var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictureIconPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon picture",
    viewBox: "0 0 32.004 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.002 0h32v32h-32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.002 28a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4zm-2-20v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-24a2 2 0 0 0-2 2zm24.289 14.066-4.432-5.557-2.6 3.518.613.811a1 1 0 1 1-1.594 1.207l-6.461-8.529-6.574 8.535a.987.987 0 0 1-.789.393.971.971 0 0 1-.609-.207 1 1 0 0 1-.186-1.4l7.375-9.578a1 1 0 0 1 .795-.393 1 1 0 0 1 .789.4l5.377 7.1 3.025-4.092a.983.983 0 0 1 .783-.408h.021a.988.988 0 0 1 .779.377l5.248 6.574a1 1 0 1 1-1.564 1.248zM23.002 11a2 2 0 1 1 2 2 2 2 0 0 1-2-2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureIconPlaceholder);
export default __webpack_public_path__ + "static/media/picture-icon-placeholder.ac3a33d2efd665f87437064a2264fb1a.svg";
export { ForwardRef as ReactComponent };